import React from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {labels} from '../../../../../util/utils';
import {
	getEntityAdmins,
	getEntityAdminsFromContacts,
	getExternalContacts,
	getInternalContacts,
	getKeyContactsFromContacts,
	getProjectOwners,
	getProjectOwnersFromContacts
} from '../../../../../util/contactsDB';

import CountDisplay, {CD_BIG} from '../../../../Common/CountDisplay';
import StyledCountSummary from './StyledCountSummary';
import {
	colorSchema,
	EA_COLOR,
	EXTERNAL_COLOR,
	INTERNAL_COLOR,
	KC_COLOR,
	PO_COLOR
} from '../../../../../util/uiconstants';

const CountSummary = ({entity, isGRARootLevel}) => {
	const allProjectOwners = useSelector(({project}) => getProjectOwners(project?.users ?? []));

	const {contacts, entityAdmins = []} = entity;

	const eyTeamObj = {
		label: labels.eyTeam,
		count: getInternalContacts(contacts).length,
		color: colorSchema[INTERNAL_COLOR]
	};
	const clientTeamObj = {
		label: labels.clientTeam,
		count: getExternalContacts(contacts).length,
		color: colorSchema[EXTERNAL_COLOR]
	};
	const poObj = {
		label: labels.projectOwnersLabel,
		count: getProjectOwnersFromContacts(allProjectOwners, contacts).length,
		color: colorSchema[PO_COLOR]
	};
	const eaObj = {
		label: labels.entityAdmins,
		count: getEntityAdminsFromContacts(entityAdmins, contacts).length,
		color: colorSchema[EA_COLOR]
	};
	const keyContactsObj = {
		label: labels.keyContacts,
		count: getKeyContactsFromContacts(contacts).length,
		color: colorSchema[KC_COLOR]
	};

	let counts = [eyTeamObj, clientTeamObj, poObj, eaObj, keyContactsObj];

	if (isGRARootLevel) counts = [poObj, keyContactsObj];

	const renderCountDisplay = ({label, count, color}, index) => {
		const props = {
			key: index,
			label,
			singleLabel: label,
			count,
			variant: CD_BIG,
			color
		};

		return <CountDisplay {...props} />;
	};

	return <StyledCountSummary>{counts.map(renderCountDisplay)}</StyledCountSummary>;
};

CountSummary.propTypes = {};

CountSummary.defaultProps = {};

export default CountSummary;
